module.exports = __webpack_public_path__ + "img/pop-head-bg.3d001997.png";